export default __webpack_public_path__ + "24214f18f0f32f7d8beb4e54b9641803.svg";